import React, { useEffect, useState } from "react";

// SUIR
import {
  Modal,
  Button,
  Input,
  Form,
  FormField,
  MessageHeader,
  Message,
} from "semantic-ui-react";

import axios from "axios";

const PropertyNotifier = ({ selectedFeature, setOpen, domain, token }) => {
  const [loading, setLoading] = useState(null);
  const [email, setEmail] = useState<string | null>(null);
  const [error, setError] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [url, setURL] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string>("");
  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[A-Za-z]{2,}$/;

  // console.log("PropertyNotifier", { selectedFeature, domain, token });

  const submit = () => {
    setLoading(true);
    setValidationError(false);
    // console.log(emailRegex.test(email.trim()));

    if (emailRegex.test(email.trim())) {
      axios
        .post(`${domain}/apps/gma/property_notifier/`, {
          parcel_no: selectedFeature.attributes.PARCEL_NO,
          email,
          authenticity_token: token,
        })
        .then(({ data }) => {
          // console.error(data);
          if (data.status === true && data.url) {
            setURL(data.url);
            const date = new Date(data.expires_at);
            setExpiresAt(
              date.toLocaleString("en-US", {
                year: "numeric",
                month: "long",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })
            );
          } else {
            setError(true);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
          setError(true);
        });
    } else {
      setValidationError(true);
      setLoading(false);
    }
  };

  return (
    <Modal onClose={() => setOpen(false)} open={true}>
      <Modal.Header style={{ fontSize: "1.1em" }}>
        Property Notifier for {selectedFeature.attributes.PARCEL_NO}
      </Modal.Header>
      <Modal.Content>
        {error && (
          <Message negative>
            <MessageHeader>Something went wrong.</MessageHeader>
            <p>
              We could not process the request at this time. Please try again
              later.
            </p>
          </Message>
        )}

        {url && (
          <>
            <p style={{ textAlign: "center" }}>
              Your submission will be reviewed. If you would not like to be
              notified you can cancel your request anytime with the link below.
              Your request will be removed on {expiresAt}
            </p>

            <div style={{ width: "80%", margin: "0 auto" }}>
              <Input
                action={{
                  icon: "copy",
                  onClick: () => {
                    navigator.clipboard.writeText(url);
                  },
                }}
                value={url}
                style={{ width: "100%" }}
              />
            </div>
          </>
        )}

        {!error && !url && (
          <>
            <p style={{ textAlign: "center" }}>
              This tool is used to sign up for email notifications for one year
              after which you will be required to re-enroll. This is not an
              automated process and emails will be reviewed by the Auditor's
              office.
            </p>
            <p style={{ textAlign: "center" }}>
              Enter your email and you will receive an email from the Auditor's
              office.
            </p>
            <br />

            <div style={{ width: "80%", margin: "0 auto" }}>
              <Form>
                <FormField
                  control={Input}
                  label="Email"
                  autoComplete="off"
                  onChange={(_i, e) => setEmail(e.value)}
                  error={
                    validationError && {
                      content: "Please enter a valid email address",
                      pointing: "above",
                    }
                  }
                />
              </Form>
            </div>
          </>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button secondary onClick={() => setOpen(false)} disabled={loading}>
          Close
        </Button>
        {!url && (
          <Button
            primary
            onClick={() => submit()}
            disabled={loading || error}
            loading={loading}
          >
            Submit
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default PropertyNotifier;
